import React, { useState } from 'react';
import { toastr }          from 'react-redux-toastr'
import * as pApi           from 'pursuit/api/pursuitApi';

export default function Newsletter() {
    const [email, setEmail] = useState('');
    let emailInput = null;

    const doSubmit = () => {
        if (email == '') {
            toastr.warning(
                'Oops!',
                'Before we can add your email to the Newsletter, you have to enter one.'
            );

            emailInput.focus();

            return false;
        }

        if (pApi.validEmail(email) === false) {
            toastr.warning(
                'Oops!',
                'The entered email address doesn\'t appear to be valid.'
            );

            emailInput.focus();

            return false;
        }

        pApi.submitNewsletter(email);
    };

    return (
        <div className="widget newsletter justify-left">
            <h2 className="widget--title white uppercase">Newsletter</h2>

            <p className="minor-margin--bottom">Subscribe to our newsletter below for updates on our posts and articles. You'll receive an email update when new content arives.</p>

            <div className="justify-center minor-margin--bottom">
                <input type="email"
                    placeholder="Email Address"
                    onChange={event => setEmail(event.target.value)}
                    onKeyDown={event => {
                        if (event.keyCode !== 13) {
                            return null;
                        }

                        doSubmit();
                    }}
                    ref={input => emailInput = input}
                />
            </div>

            <div className="justify-center">
                <div
                    className="button"
                    onClick={doSubmit}
                >
                    Subscribe
                </div>
            </div>
        </div>
    );
};
